// extracted by mini-css-extract-plugin
module.exports = {"foreground":"#abc0b7","background":"#080706"};